<template>
  <section class="space-y-8">
    <header>
      <h2 class="text-static-default-hi heading-3">
        {{ i18n(translations.title) }}
      </h2>
    </header>
    <div
      class="bg-static-default-low text-static-default-low rounded-lg body-2 space-y-20 p-24"
    >
      <RevTextList variant="ordered">
        <RevTextListItem>
          <div class="body-2-bold">
            {{ i18n(translations.step1Title) }}
          </div>
          <div class="body-2">
            {{ i18n(translations.step1) }}
          </div>
        </RevTextListItem>
        <RevTextListItem>
          <div class="body-2-bold">
            {{ i18n(translations.step2Title) }}
          </div>
          <div class="body-2">
            {{ i18n(translations.step2) }}
          </div>
        </RevTextListItem>
        <RevTextListItem>
          <div class="body-2-bold">
            {{ i18n(translations.step3Title) }}
          </div>
          <div class="body-2">
            {{ i18n(translations.step3) }}
          </div>
        </RevTextListItem>
      </RevTextList>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTextList } from '@ds/components/TextList'
import { RevTextListItem } from '@ds/components/TextListItem'

import translations from './HowItWorks.translations'

const i18n = useI18n()
</script>
